import { IActionContext } from '../helpers/ActionContext';
import { L10n } from '../L10n/L10n';
import { WorkbookContentType } from '../models/ContentTypes';
import { IWorkbookBase } from '../models/IWorkbookInfo';
import { IErrorItem } from '../../commonInfra/contentActions/MultipleItemResult';
import { Set } from '../models/Set';
import { Module } from '../Module';
import { Workbooks } from '../../content/resources/Workbooks';
import { IChangeContentTagsAction, IChangeContentTagsResult } from '../ServerApi/types/IChangeContentTagsAction';
import { ChangeTagsActionHelperService } from './ChangeTagsActionHelper';
import { ContentUrlForItem } from './ContentUrl';
import { Messages } from '../../codegen/Localize';
import {
  IErrorDetail
} from '../../commonInfra/contentActions/ActionMessages';
import {
  standardActionErrorMsg,
  standardActionSuccessMsg, StandardActionToastMessages
} from '../../commonInfra/contentActions/ActionHelpers';

export class ChangeWorkbooksTagsAction implements IChangeContentTagsAction {

  public static notificationTranslationFns: StandardActionToastMessages = {
    success: standardActionSuccessMsg(Messages.changeTagsWorkbooksSuccess),
    error: standardActionErrorMsg(Messages.changeTagsWorkbooksError),
  };

  public execute: (itemSet: Set<IWorkbookBase>, actionContext: IActionContext) => ng.IPromise<IChangeContentTagsResult>;

  public static $inject = ['ChangeTagsActionHelperService', '$translate'];

  constructor(
    private ChangeTagsActionHelper: ChangeTagsActionHelperService,
    private $translate: ng.translate.ITranslateService,
  ) {
    this.execute = ChangeTagsActionHelper.createExecuteFn<IWorkbookBase>({
      changeTagsAction: (ids: string[], addTags: string[], removeTags: string[]) => Workbooks.changeTags(ids, addTags, removeTags),
      getDescription: (workbooks: Set<IWorkbookBase>) => this.getDescription(workbooks),
      notificationFns: ChangeWorkbooksTagsAction.notificationTranslationFns,
      errorDetailFn: (errorItem: IErrorItem<IWorkbookBase>) => this.changeTagsErrorDetail(errorItem)
    });
  }

  private getDescription(workbooks: Set<IWorkbookBase>) {
    return (workbooks.size() === 1)
      ? this.$translate.instant('changeTagsWorkbookDescription', { NAME: L10n.elideIfLong(workbooks.first().name) })
      : this.$translate.instant('changeTagsWorkbooksDescription', { COUNT: workbooks.size() }, L10n.Interpolations.Count);
  }

  public changeTagsErrorDetail(errorItem: IErrorItem<IWorkbookBase>): IErrorDetail {
    return {
      itemName: errorItem.item.name,
      itemUrl: ContentUrlForItem(errorItem.item, WorkbookContentType),
      errorMessage: this.ChangeTagsActionHelper.errorMessageFor(errorItem)
    };
  }

}

Module.instance().service('ChangeWorkbooksTagsAction', ChangeWorkbooksTagsAction);
